import React from "react";
import { PhoneIcon, PhoneOffIcon, SpeakingIcon } from "../../svg";

interface UserListItemProps {
  user: {
    id: string;
    userName: string;
    image?: string;
    phone?: string;
    email?: string;
  };
  isActive: boolean;
  callStatus: string; // 'idle' | 'connecting' | 'connected'
  onCall: (e: React.MouseEvent, user: any) => void;
}

const UserListItem: React.FC<UserListItemProps> = ({
  user,
  isActive,
  callStatus,
  onCall,
}) => {
  const isCallActive = isActive && callStatus !== "idle";

  return (
    <div
      className={`w-full h-auto flex justify-between items-center gap-4 mb-6 p-2 rounded-lg transition-colors ${isActive
        ? "bg-io-blue-light/10 dark:bg-io-blue-dark/20"
        : "hover:bg-io-gray-fa dark:hover:bg-io-black-29"
        }`}
    >
      {/* Left Side: Avatar & Info */}
      <div className="flex justify-start items-center gap-4">

        {/* Avatar */}
        <div className="w-[4rem] h-[4rem] rounded-full bg-io-gray-fa overflow-hidden flex items-center justify-center border border-gray-200">
          {user.image ? (
            <img
              src={user.image}
              alt="User"
              className="w-full h-full object-cover"
              onError={(e: any) => (e.target.style.display = "none")}
            />
          ) : (
            <span className="text-[1.6rem] font-inter font-bold text-io-gray-66">
              {user.userName?.charAt(0).toUpperCase()}
            </span>
          )}
        </div>

        {/* User Details */}
        <div className="flex flex-col">
          <label className="text-[1.6rem] font-inter font-normal text-io-gray-66 dark:text-io-black-d1 cursor-default">
            {user.userName}
          </label>
          <span className="text-[1.2rem] font-inter text-io-gray-47">
            {user.email || "No Email"}
          </span>
        </div>
      </div>

      {/* Right Side: Call Button */}
      {
        isCallActive && callStatus === "connected" ? (
          // Condition 1
          <div className="transform scale-75 flex items-center justify-center">
            <SpeakingIcon className="w-[6.5rem] h-[8.5rem]" />
          </div>
        ) : (
          // Condition 3 (default button)
          <button
            type="button"
            onClick={(e) => onCall(e, user)}
            className={`w-[3.5rem] h-[3.5rem] rounded-full flex items-center justify-center text-white transition-all shadow-sm cursor-pointer bg-green-500 hover:bg-green-600`}
          >
            <div className="transform scale-75 flex items-center justify-center">
              <PhoneIcon />
            </div>
          </button>
        )
      }


    </div>
  );
};

export default UserListItem;